__turbopack_context__.v({
  "Description": "DealSentModal-module-scss-module__zs5F3q__Description",
  "Image": "DealSentModal-module-scss-module__zs5F3q__Image",
  "ImageContainer": "DealSentModal-module-scss-module__zs5F3q__ImageContainer",
  "Title": "DealSentModal-module-scss-module__zs5F3q__Title",
});
